import React, {useEffect,useState} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import reactionCombiner from "../../utils/reactionCombiner";

function ContextButton(props) {
  const store = useLocalObservable(() => ({
    context_visible:false,
    mouse_on_controll:false,
  }));

  const [comb,setComb]=useState(new reactionCombiner());

  const _onDocumentClick=()=> {
    if (!store.mouse_on_controll) {
        runInAction(() => {
          store.context_visible = false;
        });
    }
  };

  useEffect(() => {
    // mount
    comb.addReaction(()=>{
      return store.context_visible;
    },(visible)=>{
      if(visible) {
        document.addEventListener("click", _onDocumentClick);
      } else {
        document.removeEventListener("click", _onDocumentClick);
      }
    })

    return () => {
      // unmount
      comb.clear();
    }
  }, []);

  const onMouseControllEnter=()=>{
    runInAction(()=>{
      store.mouse_on_controll=true;
    });
  };
  const onMouseControllLeave=()=>{
    runInAction(()=>{
      store.mouse_on_controll=false;
    });
  };


  return props.children({
    buttonProps: {
      onMouseLeave: () => { onMouseControllLeave(); },
      onMouseEnter: () => { onMouseControllEnter(); },
      onClick: (e) => {
        e.stopPropagation();
        e.preventDefault();
        runInAction(() => {
          store.context_visible = !store.context_visible;
        });
      },
    },
    Context:(
      <div onMouseEnter={()=>{ onMouseControllEnter() }} onMouseLeave={()=>{ onMouseControllLeave(); }} className={`wsnw pa bg-w1 z4 ${store.context_visible?"":"dn"} smallShadow`} style={{top:'100%', left:0}}>
        {props.items.map((item, index)=>{
          return (
            <div key={index} className="vpadd10 hpadd10 b1 fs14 pointer bg-pc5-hover pointer tal" onClick={(e)=>{ e.stopPropagation(); e.preventDefault();  item.onClick(); store.context_visible=false; }}>{item.title}</div>
          )
        })}
      </div>
    )
  });
};

ContextButton.defaultProps = {};

ContextButton.propTypes = {}

export default observer(ContextButton);
